import React from 'react';
import { Column } from 'react-table';
import { useTranslation } from 'react-i18next';

export const useGetTop5VolumeMinColumns = (): Column<Top5ValueVolumeTableItem>[] => {
    const { t } = useTranslation();
    const columnArr: Column<Top5ValueVolumeTableItem>[] = React.useMemo(
        () => [
            {
                accessor: 'merchantId',
                Header: () => t('MID')
            },
            {
                accessor: 'volume',
                Header: 'Volume'
            }
        ],
        [t]
    );

    return columnArr;
};

export const useGetTop5ValueMinColumns = () => {
    const { t } = useTranslation();
    const columnArr: Column<Top5ValueVolumeTableItem>[] = React.useMemo(
        () => [
            {
                accessor: 'merchantId',
                Header: () => t('MID')
            },
            {
                accessor: 'value',
                Header: 'Value',
                renderType: 'currency'
            }
        ],
        [t]
    );

    return columnArr;
};
